"use client";

import Image from "next/image";
import { useLocale } from "next-intl";
import React from "react";

import Container from "../layout/Container";
import LanguageSwitcher from "./components/LanguageSwitcher";
import NavMobileMenu from "./components/NavMobileMenu";
import NavUserActions from "./components/NavUserActions";
import DesktopNavLinksWrapper from "./DesktopNavLinksWrapper";
import { usePathname, Link } from "@/i18n/routing";
import { cn } from "@/lib/utils";
import logoAr from "@/public/assets/images/albacars-ar-logo.webp";
import logo from "@/public/assets/images/albacars-logo.png";
import { navigationLinks } from "@/utils/constants";

const Navbar: React.FC = () => {
  const pathname = usePathname();
  const locale = useLocale();

  // Define which paths should have sticky navbar
  const stickyPaths = ["/"];
  const isSticky = stickyPaths.includes(pathname);

  const currentLogo = locale === "ar" ? logoAr : logo;

  return (
    <div className={`bg-white py-5 ${isSticky ? "sticky top-0 z-50" : ""}`}>
      <Container>
        <header className="header">
          <nav className="flex items-center justify-between text-[#000]">
            <div className="relative min-w-[140px] lg:min-w-[130px] xl:min-w-[140px] 2xl:min-w-[180px]">
              <Link href="/">
                <Image
                  src={currentLogo}
                  alt="logo"
                  priority
                  quality={100}
                  width={0}
                  height={45}
                  className="object-cover object-center"
                  sizes="(max-width: 640px) 120px,
                  (max-width: 768px) 140px,
                  (max-width: 1024px) 130px,
                  (max-width: 1280px) 100px,
                  (max-width: 1536px) 140px,
                 180px"
                />
              </Link>
            </div>

            {/* Desktop Menu */}
            <DesktopNavLinksWrapper navigationLinks={navigationLinks} />

            {/* Icons and Menu Button */}
            <div className={cn("flex items-center", locale === "ar" ? "space-x-2 space-x-reverse" : "space-x-0 gap-1")}>
              <div className="ultrawide:hidden">
                <LanguageSwitcher />
              </div>
              <div className="hidden lg:flex">
                <NavUserActions />
              </div>
              <NavMobileMenu />
            </div>
          </nav>
        </header>
      </Container>
    </div>
  );
};

export default Navbar;
